// 配置信息
export default {
  // 粤ICP备19100595号 
  icp: '19100595',
  contact: {
    customerService: '0755 8656 8909', // 客服热线
    preSalesService: 'sales@zhuoruint.com', // 售前服务
    technicalSupport: 'support@zhuoruint.com' // 技术支持
  },
  // 下载地址（中转页）
  downloadUrl: {
    url: {
      ios: "https://h5pro.zr66.com/zhuorui_h5/transferStation?source=share",
      android: "https://h5pro.zr66.com/zhuorui_h5/transferStation?source=share"
    },
    // 唤起app
    scheme: {
      ios: "zhuoruischeme://",
      android: "zhuorui://securities/main"
    }
  },
  appStore: {
    ios: 'https://apps.apple.com/cn/app/%E5%8D%93%E9%94%90%E8%AF%81%E5%88%B8-%E6%B8%AF%E7%BE%8E%E8%82%A1%E6%8A%95%E8%B5%84%E5%B9%B3%E5%8F%B0/id1593128690',
    android: 'https://osspublicpro.zr66.com/common/download/android/zr_release_last.apk'
  }
};



//////////////////
// WEBPACK FOOTER
// ./static/config/config.js
// module id = D08P
// module chunks = 6